<template>
  <Dialog
    v-model:visible="mostrarModal"
    :style="{ width: '350px' }"
    header="Procendencia Detalle"
    :modal="true"
    class="p-fluid"
    @hide="ocultarDialog"
  >
    <div class="col-12">
      <div class="p-fluid formgrid grid">
        <div class="field col-12 md:col-12">
          <label for="nombre"
            ><strong>NOMBRE PROCEDENCIA: </strong>
            <span class="p-invalid">*</span></label
          >
          <InputText
            id="nombre"
            v-model="data_procedencia.nombre"
            required="true"
            autofocus
            @keydown.enter="saveProcedencia"
          />
          <small class="p-invalid" v-if="errors.nombre">{{
            errors.nombre[0]
          }}</small>
        </div>
        <div class="field col-12 md:col-12">
          <label for="estado"
            ><strong>Estado: </strong><span class="p-invalid">*</span></label
          >
          <Dropdown
            id="estado"
            v-model="data_procedencia.estado"
            :disabled="!data_procedencia.id"
            :options="estados"
            optionLabel="label"
            placeholder="Seleccione un estado..."
          >
            <template #value="slotProps">
              <span
                :class="'product-badge ' + claseEstado[slotProps.value.value]"
              >
                {{ slotProps.value.label }}
              </span>
            </template>
          </Dropdown>
        </div>
      </div>
    </div>
    <template #footer>
      <div class="field">
        <label class="flex md:justify-content-start"
          ><strong>Campos Requeridos: </strong>
          <span class="p-invalid">*</span></label
        >
      </div>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        class="p-button-secondary p-button-lg"
        @click="ocultarDialog"
        :disabled="!enviado ? false : true"
      />
      <Button
        label="Guardar"
        icon="pi pi-check"
        class="p-button-primary p-button-lg"
        @click="saveProcedencia"
        :disabled="!enviado ? false : true"
        :loading="enviado"
      />
    </template>
  </Dialog>
</template>

<script>
import ProcedenciaService from "@/service/ProcedenciaService";
export default {
  emits: ["closeModal", "actualizarListado"],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    procedencia: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  data() {
    return {
      mostrarModal: this.show,
      data_procedencia: this.procedencia,
      enviado: false,
      estados: [
        { label: "ACTIVO", value: 1 },
        { label: "INACTIVO", value: 0 },
      ],
      errors: {},
      claseEstado: ["status-outofstock", "status-instock"],
    };
  },
  procedenciaService: null,
  created() {
    this.procedenciaService = new ProcedenciaService();
  },
  methods: {
    ocultarDialog() {
      this.errors = {};
      this.mostrarModal = false;
      this.$emit("closeModal");
    },
    saveProcedencia() {
      this.errors = {};
      this.enviado = true;
      //editar procedencia
      if (this.data_procedencia.id) {
        let procedencia_enviar = {
          ...this.data_procedencia,
          estado: this.data_procedencia.estado.value,
        };
        this.procedenciaService
          .updateProcedencia(procedencia_enviar)
          .then((data) => {
            if (Object.prototype.hasOwnProperty.call(data, "errors")) {
              this.errors = data.errors;
            } else {
              this.errors = {};
              this.$toast.add({
                severity: "success",
                summary: "Exito!",
                detail: data.mensaje,
                life: 3000,
              });
              this.$emit("actualizarListado");
              this.ocultarDialog();
            }
            this.enviado = false;
          });
      } else {
        //CREANDO UN NUEVO PUNTO DE VENTA
        let tmp = {
          ...this.data_procedencia,
          estado: this.data_procedencia.estado.value,
        };
        this.procedenciaService
          .sendProcedencia(tmp)
          .then((data) => {
            if (Object.prototype.hasOwnProperty.call(data, "errors")) {
              this.errors = data.errors;
              this.data_procedencia = tmp;
            } else {
              this.errors = {};
              this.$toast.add({
                severity: "success",
                summary: "Exito!",
                detail: data.mensaje,
                life: 10000,
              });
              this.$emit("actualizarListado", data.procedencia);
              this.ocultarDialog();
            }
            this.enviado = false;
          });
      }
    },
  },
  watch: {
    show(val) {
      this.mostrarModal = val;
    },
    procedencia(val) {
      this.data_procedencia = val;
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/demo/badges.scss";
.p-invalid {
  color: red;
}
</style>